<template>
  <div id="change-due-date-dialog">
    <ipub-model :title="'Transfer'"
                width="470px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p2 mar-b-30">After confirmation, an email will be sent to the author and the Manager Editor of the corresponding journal.</div>
      <ipub-form ref="transfer-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="journalId"
                        label="journal">
          <ipub-select v-model="params.journalId"
                       @change="onJournalChange"
                       placeholder="Select Journal"
                       :options="journalList" />
        </ipub-form-item>
        <ipub-form-item prop="typeCode"
                        label="Article Type">
          <ipub-select v-model="params.typeCode"
                       optionKey="code"
                       placeholder="Select Article Type"
                       :options="articleTypeList" />
        </ipub-form-item>
        <ipub-form-item prop="specialId"
                        label="Special Issue">
          <ipub-select v-model="params.specialId"
                       search
                       :clear="true"
                       @search="getSpecial"
                       optionTitle="titleText"
                       placeholder="Select Special Issue"
                       :options="specialIssueList" />
        </ipub-form-item>
        <ipub-form-item v-if="journalInfo.displaySection"
                        prop="sectionIdList"
                        label="Section">
          <ipub-select v-model="params.sectionId"
                       :tree="true"
                       :clear="true"
                       placeholder="Select Section"
                       :options="sectionList" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import journal from '@/api/journal'
import section from '@/api/section'
import specialApi from '@/api/special'
import { editor } from '@/api/editor'
import { settingJournalAtype } from '@/api/setting'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
    journalList: {
      type: Array,
      default () {
        return []
      }
    },
  },
  data () {
    return {
      journalInfo: {},
      params: {
        journalId: '',
        typeCode: '',
        specialId: '',
        sectionId: ''
      },
      specialIssueList: [],
      articleTypeList: [],
      sectionList: [],
      rules: {},

      getSpecial: '',
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
        this.journalInfo = {}
      } else {
        this.getRules()
        const { journal, journalId, typeCode, sign } = this.inputData
        this.params = {
          journalId,
          typeCode,
          specialId: '',
          sectionId: '',
          sign
        }
        this.journalInfo = journal
        this.getSpecial = help.debounce(async val => {
          this.specialIssueList = await specialApi.submitManuscript({
            journalId: this.params.journalId,
            title: val
          })
        }, 1000)
        this.onJournalChange()
      }
    }
  },
  methods: {
    onJournalChange () {
      this.getType()
      this.getSpecial()
      this.getSection()
      this.queryJournal()

      this.params.specialId = ''
      this.params.sectionId = ''
    },
    async queryJournal () {
      this.journalInfo = await journal.query(this.params.journalId)
    },
    async getType () {
      this.articleTypeList = await settingJournalAtype.getAll({
        released: true,
        journalId: this.params.journalId
      })
      const flag = this.articleTypeList.some(item => {
        return item.code === this.params.typeCode
      })
      if (!flag) {
        this.params.typeCode = ''
      }
    },
    async getSection () {
      this.sectionList = await section.getAll({
        journalId: this.params.journalId
      })
    },
    async confirm () {
      const flag = this.$refs['transfer-form'].validate()
      if (!flag) {
        return
      }
      await editor.transfer(this.inputData.id, this.params)
      this.$message.success({ title: 'Success', content: `The manuscript transfer successful!` })
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        journalId: [
          {
            required: true,
            message: 'journal' + this.LANGUAGE[this.language].noEmpty
          }
        ],
        typeCode: [
          {
            required: true,
            message: 'Article Type' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
